class QuantityBundle extends HTMLElement{
    constructor() {
        super();
    }
        connectedCallback() {
            this.cartDrawer = document.querySelector('cart-drawer');
            this.quantityBundleSubmit = this.querySelector('.quantity-bundle__submit');
            this.mainProductId = this.querySelector("#variant-id").value;
            this.variantBundle = this.hasAttribute("data-variant");
            if (this.quantityBundleSubmit) {
                this.quantityBundleSubmit.addEventListener('click', this.handleAddToCart.bind(this));
            }
            this.purchaseInputs = this.querySelectorAll("quantity-bundle input[name='quantity-bundle']");
            this.initMedia();
            this.purchaseInputs.forEach((purchaseInput)=>{
                    purchaseInput.addEventListener("change", function(e){   
                        const featuredImage = purchaseInput.getAttribute("data-media-id");
                            if(featuredImage){
                                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(featuredImage)
                                );
                            }
                    })
                    })
        }


        initMedia(){
            const activeInputId = this.querySelector("quantity-bundle input[name='quantity-bundle']:checked")?.getAttribute("data-media-id");
            if(activeInputId){
                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(activeInputId)                         
                                );
            }
        }



        async handleAddToCart() {
        const addButton = this.quantityBundleSubmit;
        const loadingOverlay = addButton?.querySelector('.loading-overlay');
        
        if (!addButton || addButton.disabled) return;
    
        addButton.disabled = true;
        loadingOverlay?.classList.remove('hidden');
        try {
            const checkedQuantity = this.querySelector("input[name='quantity-bundle']:checked").value;
            const checkedVariant = this.querySelector("input[name='quantity-bundle']:checked").closest(".quantity-bundle__item");
            const gifts = checkedVariant.querySelectorAll(".quantity-bundle__gift[data-product]");
            const currentVariantId = checkedVariant.querySelector("#current-variant-id")?.value;
            this.cartDrawer = document.querySelector('cart-drawer');
            const formData = new FormData();
            const variantID = this.variantBundle ? currentVariantId : this.mainProductId;
            const quantity = this.variantBundle ? 1 : parseInt(checkedQuantity);
             formData.append("id", variantID);
             formData.append("quantity", quantity);
            if(gifts && gifts.length>0){
                gifts.forEach((gift, index)=>{
                const variantId = gift.dataset.product;
                formData.append(`items[${index}][id]`, variantId);
                formData.append(`items[${index}][quantity]`, '1');
                })
            }
             if (this.cartDrawer) {
                const sections = this.cartDrawer.getSectionsToRender?.()?.map(section => section.section);
                if (sections) {
                    formData.append('sections', sections.join(','));
                }
                formData.append('sections_url', window.location.pathname);
                }
                console.log(...formData)
           // Add items to cart
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
                });

                if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to add items to cart');
                }
                
                const result = await response.json();
                // Update cart drawer if available
                if (this.cartDrawer && result.sections) {
                this.cartDrawer.renderContents(result);
                this.cartDrawer.open();
                }

                // Dispatch cart update event
                document.dispatchEvent(new CustomEvent('cart:updated', { 
                detail: { items: result.items || [] }
                }));
        
        
        } catch (error) {
            console.error('Error adding items to cart:', error);
        } finally{
             // Hide loading state
            loadingOverlay?.classList.add('hidden');
            addButton.disabled = false;
        }
    }
}
if (!customElements.get('quantity-bundle')) {
    customElements.define('quantity-bundle', QuantityBundle);
  }



